import React from "react"
import { Box, IconButton } from "@mallardbay/lib-react-components"
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { SIZES } from "@mallardbay/lib-shared-helpers"

import useChatAttachmentChipStyles from "~components/shared/chat/use-chat-attachment-chip-styles"
import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/constants"

interface Props {
    readonly children: React.ReactNode
    readonly testId?: string
    readonly onRemove?: () => void
}

export default function ChatAttachmentChip({
    children,
    testId,
    onRemove,
}: Props) {
    const styles = useChatAttachmentChipStyles()

    return (
        <Box style={styles.chip} testId={testId}>
            {children}
            {onRemove ? (
                <IconButton
                    testId={TEST_IDS.CHAT_INPUT_REMOVE_ATTACHMENT_BUTTON}
                    icon={<FontAwesomeIcon icon={faXmark} />}
                    ariaLabel={COPY.AI_CHAT_REMOVE_ATTACHMENT_ARIA}
                    onClick={onRemove}
                    size={SIZES.XS}
                />
            ) : null}
        </Box>
    )
}
